<template>
  <div class="bill-templates page--bill-templates">
    <div class="page__header">
      <div class="page__title">
        <router-link :to="backLinkRoute" class="page__back-link">
          <arrow-button
            class="page__back-link-icon"
            :rotated180="true"
          ></arrow-button>
        </router-link>
        <div class="page__title-text">
          {{ $t('bill-templates.page.title') }}
        </div>
      </div>
    </div>
    <div class="bill-templates__content">
      <div class="bill-templates__title">
        {{ $t('bill-templates.list.title') }}
      </div>
      <div class="bill-templates__list">
        <bill-template
          :company-id="id"
          class="bill-templates__item"
          v-for="template in templates"
          :template="template"
          :key="`template-${template.id}`"
          @deleted="handleTemplateDeleted(template)"
          @click="createBillByTemplate(template)"
        ></bill-template>
      </div>
    </div>

    <!-- POPUP / NOTIFICATIONS    -->
    <bill-deleted-notification
      ref="billDeletedNotification"
    ></bill-deleted-notification>
  </div>
</template>

<script>
import ArrowButton from '@vue-app/components/base/button/ArrowButton.vue'
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'
import BillTemplate from '@vue-app/components/company/bills/BillTemplate.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import BillDeletedNotification from '@vue-app/components/company/bills/popup/notification/BillDeletedNotification.vue'
import { CompaniesApi } from '@js-app/office/api/companies-api'
import RequireAccess from '@vue-app/components/base/role-based/RequireAccess.vue'

export default {
  name: 'BillTemplates',
  props: ['id'],
  components: {
    RequireAccess,
    BillDeletedNotification,
    NoBgButton,
    PrimaryButton,
    BillTemplate,
    ArrowButton,
  },
  data() {
    return {
      templates: [
        {
          id: 1,
          name: 'Test 1',
        },
        {
          id: 2,
          name: 'Test 2',
        },
        {
          id: 3,
          name: 'Test 3',
        },
      ],
    }
  },
  computed: {
    backLinkRoute() {
      return RouteHelper.getRoute('bill-create-types', { companyId: this.id })
    },
  },
  created() {
    this.loadTemplates()
  },
  methods: {
    handleTemplateDeleted(template) {
      this.templates.splice(
        this.templates.findIndex((_t) => _t.id === template.id),
        1
      )

      this.$refs.billDeletedNotification.show()
    },
    createBillByTemplate(template) {
      this.$router.push(
        RouteHelper.getRoute('bill-create-by-template', {
          companyId: this.id,
          templateId: template.id,
        })
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--bill-templates {
    padding-top: 28px;
  }

  &__header {
    margin-bottom: 24px;
  }
}
.bill-templates {
  &__content {
    margin-top: 31px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #465a8b;
    margin-left: 50px;
  }

  &__list {
    margin-top: 34px;
    display: grid;
    grid-template-columns: auto auto auto;
    column-gap: 18px;
  }
}
</style>
